<script lang="ts">
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let course: CourseType = props.course

  let course_image = new URL(
    `/images/courses/e${course.id}_sm.jpg`,
    import.meta.url
  ).href
</script>

<div class="pt-3">
  <div
    class="relative rounded-lg shadow-xl overflow-hidden bg-gray-800 opacity-60"
  >
    <img
      src={course_image}
      class="absolute inset-0 h-full w-full object-cover"
      alt={course.name}
    />
    <div class="relative px-8">
      <div class="mt-8">
        <div
          class="my-12 relative py-4 px-8 rounded justify-center rounded bg-black opacity-90"
        >
          <p class="text-center text-2xl font-medium text-white">
            Welcome to the preview for the {course.name} course.
          </p>
          <p class="text-lg mt-4 text-white">
            {#if course.id == 1}
              You are welcome to preview the first two modules of this course
              and then when you are ready to unlock the complete course, click
              the "Purchase Course" button.
            {:else if course.id == 2}
              You are welcome to preview the first module of this course and
              then when you are ready to unlock the complete course, click the
              "Purchase Course" button.
            {:else}
              You are welcome to preview the first step of this course and then
              when you are ready to unlock the complete course, click the
              "Purchase Course" button.
            {/if}
          </p>
          <p class="text-lg mt-4 text-white">
            By purchasing this course, it will be made available ALL members on
            your current plan, which is: <span class="font-bold">
              {appStore.plan.name}
            </span>.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
